import AES from 'crypto-js/aes';
import CryptoJSCore from 'crypto-js/core';

export const getCookie = (name) => {
    var cookieValue;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
};

export function delete_cookie(name, path, domain) {
    if (get_cookie(name)) {
        document.cookie = name + "=" +
            ((path) ? ";path=" + path : "") +
            ((domain) ? ";domain=" + domain : "") +
            ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}
export function get_cookie(name) {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
}

//export const translations = JSON.parse((document.getElementById('__translations') || {}).textContent || "{}");
export const context = JSON.parse((document.getElementById('__ctx') || {}).textContent || "{}");

export const staticUrl = document.location.host.includes('spotimplant.com') ? "https://assets.spotimplant.com/static/" : "/static/";

export function decrypt(base, key, iv) {
    key = CryptoJSCore.enc.Utf8.parse(key);
    iv = CryptoJSCore.enc.Utf8.parse(iv);

    var decrypted = AES.decrypt(base, key, { iv: iv, mode: CryptoJSCore.mode.CBC });

    return decrypted.toString(CryptoJSCore.enc.Utf8);

}

export const buildUrl = (baseUrl, getParams) => {

    if (!getParams) {
        return baseUrl;
    }
    const searchParams = new URLSearchParams(removeUndefined(getParams));
    const url = `${baseUrl}?${searchParams.toString()}`;
    return url;
};


export const removeUndefined = obj => Object.entries(obj).reduce((a, [k, v]) => (v === undefined ? a : { ...a, [k]: v }), {});


export const removeEmpty = obj => Object.entries(obj).reduce((a, [k, v]) => (v === undefined || v === null ? a : { ...a, [k]: v }), {});

